<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('my.sys_notice')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="listItem" v-for="(v,key) in notice" :key="key">
            <div class="listTitle" style="display: none">{{ v.name }}</div>
            <div class="listContent html"><p>{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:{},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        console.log(res);
        this.notice = res.data
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #211923 url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png") no-repeat top center;
  background-size: cover;
}

.page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
      linear-gradient(180deg, rgba(18,14,20,.25) 0%, rgba(44,25,47,.55) 48%, rgba(88,53,83,.82) 100%),
      rgba(30,20,33,.25);
}

.page > * {
  position: relative;
  z-index: 1;
}

.nav-bar {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
}

::v-deep .van-nav-bar__left {
  left: 18px;
}

::v-deep .van-icon-arrow-left {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255,255,255,.18);
  font-size: 40px !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #fff;
  font-size: 32px;
}

::v-deep .van-loading__text {
  color: #fff;
  font-size: 32px;
}

.content {
  height: calc(100vh - 92px);
  overflow-y: auto;
  padding: 60px 26px 40px;
  box-sizing: border-box;
}

.listItem {
  margin-bottom: 22px;
  padding: 26px 28px 20px;
  border-radius: 24px;
  color: #fff;
  background: rgba(112, 99, 110, 0.72);
  border: 1px solid rgba(255,255,255,.16);
  box-shadow:
      0 18px 34px rgba(0,0,0,.22),
      inset 0 1px 0 rgba(255,255,255,.22);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.listTitle {
  font-size: 34px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 12px;
}

.listContent {
  padding: 8px 0 18px;
  border-bottom: 1px solid rgba(255,255,255,.12);
  font-size: 28px;
  line-height: 1.7;
  color: rgba(255,255,255,.9);
  font-weight: 600;
}

.listContent p {
  margin: 0;
}

.listTime {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 62px;
}

.listTimeText {
  color: rgba(255,255,255,.58);
  font-size: 24px;
  font-weight: 600;
}
</style>